export default "__VITE_ASSET__ChdjXQig__"